import { TicketApi } from '@/api/ticket';
import TicketStore from '@/store/ticket';
import { StoreService } from '@/services/store-service';

export class TicketService {

    constructor(client, store, router) {                
        this.api = new TicketApi(client);
        this.store = StoreService.new(store, TicketStore); 
        this.router = router;
    } 

    async getTicket(id){
        if(this.store.get('ticket') != null && id == this.store.get('ticket').id){
            const cachedItems = this.store.get('ticket');
            if(cachedItems) return cachedItems;
        }

        const response = await this.api.getTicket(id);
        await this.store.dispatch('getTicket', response.ticket);
        return response.ticket;
    }

    async createTicket(data){
        const response = await this.api.createTicket(data);
        return response;
    }
}